const ComponentToRender = ({ version }: { version: string }) => {
  return <div>ComponentToRender - {version}</div>
}

export default ComponentToRender
